import React, { useState, useEffect } from 'react';
import { FaHome, FaCogs, FaImages, FaEnvelope, FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import './Dock.css';
import { useAuth } from '../contexts/AuthContext';

// Map between route paths and section IDs
const routeToSectionMap = {
  '/': 'home',
  // '/about': 'about',
  '/services': 'services',
  '/gallery': 'gallery',
  '/contact': 'contact'
};

const Dock = () => {
  const [isHidden, setIsHidden] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [activeSection, setActiveSection] = useState('home');
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, logout } = useAuth();
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);

  // Set active section based on current route
  useEffect(() => {
    const currentPath = location.pathname;
    const sectionId = routeToSectionMap[currentPath] || 'home';
    setActiveSection(sectionId);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Hide/show dock based on scroll direction
      if (Math.abs(lastScrollTop - currentScrollTop) > 10) {
        setIsHidden(currentScrollTop > lastScrollTop);
        setLastScrollTop(currentScrollTop);
      }
    };

    const handleMouseMove = (e) => {
      // Show dock when mouse moves to bottom of screen
      const windowHeight = window.innerHeight;
      const bottomThreshold = windowHeight - 100;
      if (e.clientY > bottomThreshold) {
        setIsHidden(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [lastScrollTop]);

  const handleDockItemClick = (itemId) => {
    setActiveSection(itemId);
    
    // Navigate to the corresponding route
    switch(itemId) {
      case 'home':
        navigate('/');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        break;
      // case 'about':
      //   navigate('/about');
      //   window.scrollTo({ top: 0, behavior: 'smooth' });
      //   break;
      case 'services':
        navigate('/services');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        break;
      case 'gallery':
        navigate('/gallery');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        break;
      case 'contact':
        navigate('/contact');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        break;
      case 'profile':
        navigate('/dashboard');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        break;
      default:
        navigate('/');
    }
  };

  const handleProfileClick = () => {
    setActiveSection('profile');
    navigate('/dashboard');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setProfileDropdownOpen(false);
  };
  const handleLogout = async () => {
    await logout();
    setProfileDropdownOpen(false);
  };

  const dockItems = [
    { id: 'home', icon: <FaHome />, label: 'Home' },
    // { id: 'about', icon: <FaUser />, label: 'About' },
    { id: 'services', icon: <FaCogs />, label: 'Services' },
    { id: 'gallery', icon: <FaImages />, label: 'Gallery' },
    { id: 'contact', icon: <FaEnvelope />, label: 'Contact' }
  ];

  return (
    <div className={`dock-container ${isHidden ? 'dock-hidden' : ''}`}>
      {dockItems.map((item) => (
        <div 
          key={item.id}
          className={`dock-item ${activeSection === item.id ? 'active' : ''}`}
          onClick={() => handleDockItemClick(item.id)}
        >
          <div className="dock-label">{item.label}</div>
          <div className="dock-icon">
            {item.icon}
          </div>
        </div>
      ))}
      {currentUser && (
        <div 
          key="profile"
          className={`dock-item profile-dock-item ${activeSection === 'profile' ? 'active' : ''}`}
          onMouseEnter={() => setProfileDropdownOpen(true)}
          onMouseLeave={() => setProfileDropdownOpen(false)}
        >
          <div className="dock-label">Profile</div>
          <div className="dock-icon">
            <FaUserCircle />
          </div>
          {profileDropdownOpen && (
            <div className="profile-dropdown">
              <div className="profile-dropdown-item" onClick={handleProfileClick}>Dashboard</div>
              <div className="profile-dropdown-item" onClick={handleLogout}>
                <FaSignOutAlt style={{ marginRight: '8px' }} />Logout
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Dock;